import { Component, OnChanges, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {  LocationServiceDto} from 'src/shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { DateTimeHelper } from 'src/app/helpers/datetime'
import { ServicesItemModel } from '../models';
import { Router } from '@angular/router';
import { Dashboard } from 'powerbi-client';
import { DashboardMode } from 'src/app/dashboard-live/dashboard-live.component';

@Component({
  selector: 'app-widget-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesWidgetComponent implements OnChanges, OnInit {
  // Inputs
  @Input()
  services: LocationServiceDto[]

  @Input()
  showFullDate: boolean = false;
  
  @Input()
  dashboardMode: DashboardMode = DashboardMode.Normal;

  @Output()
  onExport: EventEmitter<any> = new EventEmitter();

  private isOnExportUsed = false;

  DashboardMode = DashboardMode;

  // Private variables

  // Public variables
  servicesPage: ServicesItemModel[] = [];

  constructor(private router: Router) { }

  ngOnChanges(changes) {
    if (changes.services.firstChange === false) {
      this.updateView();
    }
  }

  ngOnInit(): void {
    this.isOnExportUsed = this.onExport.observers.length > 0;
  }

  updateView() {
    let page:  ServicesItemModel[] = [];
    this.services.forEach(service => {
        page.push(this.MapDtoToModel(service));
    });

    this.servicesPage = page;
  }

  showVariance() {
    return true; // this.services?.some(s => s.variance);
  }  

  goToLocation(locationId: string) {
    this.router.navigate([`/location/${locationId}`]);
  }

  exportData(): void {
    this.onExport.emit();
  }

  MapDtoToModel(dto: LocationServiceDto): ServicesItemModel {
    let model: ServicesItemModel = dto;
    model.timeAtSiteFormatted = DateTimeHelper.formatTimespan(model.timeAtSite);
    if (this.showFullDate) {
      model.arrivedAtFormatted = DateTimeHelper.formatDateAndTime(model.arrivedAt);
      model.departedAtFormatted = DateTimeHelper.formatDateAndTime(model.departedAt);
    } else {
      model.arrivedAtFormatted = DateTimeHelper.formatDateToTime(model.arrivedAt);
      model.departedAtFormatted = DateTimeHelper.formatDateToTime(model.departedAt);
    }
    return model;
  }

}
